// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import WipProductTracking from '@deere/cps-it.warranty-model-factory/lib/wip-product-tracking';
import WipProductTrackingItem from './wip-item';

const WipProductTrackings = props =>
    <div>
        <div className='wip-product-tracking'>
            <WipProductTrackingItem
                className={props.wipProductTracking.registrationReviews > 0 ? 'dot-icon-yellow' : ''}
                count={props.wipProductTracking.registrationReviews}
                status='REGISTRATIONS_REVIEW'
            />
        </div>
        <div className='wip-product-tracking'>
            <WipProductTrackingItem
                className={props.wipProductTracking.transferApprovals > 0 ? 'dot-icon-yellow' : ''}
                count={props.wipProductTracking.transferApprovals}
                status='TRANSFER_APPROVALS'
            />
        </div>
    </div>;

WipProductTrackings.displayName = 'WipProductTrackings';
WipProductTrackings.propTypes = {
    wipProductTracking: PropTypes.instanceOf(WipProductTracking).isRequired
};

export default WipProductTrackings;



// WEBPACK FOOTER //
// ./src/home-page/components/wip-product-tracking.js